export * from './bill-of-material-scan-modal.component'